import React, { useState, useContext } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { DataContext as SharedDataContext } from '../../../stores/crm-store';

const GenericDeleteDetailsDropdownModal = ({ title, description, handleDelete }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const { dispatch } = useContext(SharedDataContext);

    const onConfirm = async () => {
        const response = await handleDelete();
        if (response.success) {
            dispatch({ type: 'SHOW_DELETED_TOAST' });
        } else {
            dispatch({ type: 'SHOW_ERROR_TOAST' });
            alert('Objektet kunde inte raderas. Vänligen kontakta alltid@consid.se om problemet kvarstår efter att du uppdaterat sidan.');
        }
    };

    return (
        <>
            <div onClick={handleShow}>Radera</div>
            <Modal show={show} onHide={handleClose} className='crm-add-item-modal'>
                <div className='d-flex justify-content-between align-items-center padding-top-20px padding-left-20px padding-right-20px'>
                    <h4 className='margin-none'>Radera : {title}</h4>
                    <button type='button' className='btn btn-secondary crm-modal-btn ' onClick={handleClose}>
                        &times;
                    </button>
                </div>
                <div className='add-item-form'>
                    <Modal.Body>
                        <div>{description} </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant='light' onClick={handleClose}>
                            Avbryt
                        </Button>
                        <Button variant='danger' onClick={onConfirm}>
                            Radera
                        </Button>
                    </Modal.Footer>
                </div>
            </Modal>
        </>
    );
};

export default GenericDeleteDetailsDropdownModal;
